import { createSlice } from "@reduxjs/toolkit";
import { projectCreate } from "./projectAsyncThunk";

const projectCreateSlice = createSlice({
  name: "project",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFail: false,
  },
  reducers: {},
  extraReducers: {
    [projectCreate.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFail = false;
    },
    [projectCreate.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
    },
    [projectCreate.rejected]: (state, action) => {
      state.isLoading = false;
      state.isFail = true;
    },
  },
});

export default projectCreateSlice.reducer;
